import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-scroll-outer" }
const _hoisted_6 = { class: "table-scroll-mobile" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = { class: "shadow-none fw-medium text-black title ps-0" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = {
  key: 0,
  class: "badge bg-outline-danger"
}
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = {
  key: 0,
  class: "badge text-bg-success rounded-pill"
}
const _hoisted_17 = {
  key: 1,
  class: "badge text-bg-warning rounded-pill"
}
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-paragraph text-end pe-0" }
const _hoisted_19 = { class: "dropdown" }
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_23 = { class: "mb-0 text-paragraph" }
const _hoisted_24 = { class: "fw-bold" }
const _hoisted_25 = { class: "fw-bold" }
const _hoisted_26 = { class: "fw-bold" }
const _hoisted_27 = { class: "mt-15 mt-md-0" }
const _hoisted_28 = { class: "pagination mb-0" }
const _hoisted_29 = {
  key: 0,
  class: "page-item"
}
const _hoisted_30 = {
  key: 1,
  class: "page-item disabled"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 2,
  class: "page-item disabled"
}
const _hoisted_33 = {
  key: 3,
  class: "page-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/add-product",
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" Nouveau Produit ", -1),
            _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
          ])),
          _: 1,
          __: [4]
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                }, " Produit "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Nom du produit "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Quantité "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Statut "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                }, " Actions ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("th", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_router_link, {
                        to: "/product-details",
                        class: "d-flex align-items-center text-decoration-none text-black ms-8 fs-md-15 fs-lg-16"
                      }, {
                        default: _withCtx(() => [
                          (row.pic)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: row.pic,
                                class: "me-15",
                                width: "44"
                              }, null, 8, _hoisted_10))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: require('@/assets/images/NoImage.png'),
                                class: "me-15",
                                width: "44"
                              }, null, 8, _hoisted_11))
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(row.name), 1),
                  _createElementVNode("td", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.inventories, (item) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: item.id
                      }, [
                        _createVNode(_component_center, null, {
                          default: _withCtx(() => [
                            _createElementVNode("b", null, _toDisplayString(item.inventory_ref), 1),
                            _createTextVNode(" " + _toDisplayString(item.qty) + " | " + _toDisplayString(item.qty_not_received) + " ", 1),
                            (item.archived == 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Archivé "))
                              : _createCommentVNode("", true),
                            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                          ]),
                          _: 2,
                          __: [5]
                        }, 1024)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    (row.received == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Reçu "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, " Pas encore reçu "))
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[7] || (_cache[7] = _createElementVNode("button", {
                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createElementVNode("i", { class: "flaticon-dots" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_20, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            onClick: _withModifiers(($event: any) => (
                          _ctx.$router.push({
                            name: 'EditProductPage',
                            params: { id: row.id },
                          })
                        ), ["prevent"])
                          }, _cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Modifier", -1)
                          ]), 8, _hoisted_21)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("p", _hoisted_23, [
          _cache[9] || (_cache[9] = _createTextVNode(" Showing ", -1)),
          _createElementVNode("span", _hoisted_24, _toDisplayString((_ctx.filter.current_page - 1) * _ctx.filter.per_page + 1), 1),
          _cache[10] || (_cache[10] = _createTextVNode(" – ", -1)),
          _createElementVNode("span", _hoisted_25, _toDisplayString(Math.min(_ctx.filter.current_page * _ctx.filter.per_page, _ctx.filter.total)), 1),
          _cache[11] || (_cache[11] = _createTextVNode(" out of ", -1)),
          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.filter.total), 1),
          _cache[12] || (_cache[12] = _createTextVNode(" results ", -1))
        ]),
        _createElementVNode("nav", _hoisted_27, [
          _createElementVNode("ul", _hoisted_28, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === 1 }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                href: "javascript:void(0)",
                "aria-label": "Previous",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page - 1)))
              }, " ‹ ")
            ], 2),
            (_ctx.pages[0] !== 1)
              ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                  _createElementVNode("a", {
                    class: "page-link",
                    href: "javascript:void(0)",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(1)))
                  }, "1")
                ]))
              : _createCommentVNode("", true),
            (_ctx.pages[0] > 2)
              ? (_openBlock(), _createElementBlock("li", _hoisted_30, _cache[13] || (_cache[13] = [
                  _createElementVNode("span", { class: "page-link" }, "...", -1)
                ])))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                key: page,
                class: "page-item"
              }, [
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  class: _normalizeClass(["page-link", { active: _ctx.filter.current_page === page }]),
                  onClick: ($event: any) => (_ctx.goToPage(page))
                }, _toDisplayString(page), 11, _hoisted_31)
              ]))
            }), 128)),
            (_ctx.pages[_ctx.pages.length - 1] < _ctx.filter.last_page - 1)
              ? (_openBlock(), _createElementBlock("li", _hoisted_32, _cache[14] || (_cache[14] = [
                  _createElementVNode("span", { class: "page-link" }, "...", -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.pages[_ctx.pages.length - 1] !== _ctx.filter.last_page)
              ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                  _createElementVNode("a", {
                    class: "page-link",
                    href: "javascript:void(0)",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage(_ctx.filter.last_page)))
                  }, _toDisplayString(_ctx.filter.last_page), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === _ctx.filter.last_page }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                href: "javascript:void(0)",
                "aria-label": "Next",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page + 1)))
              }, " › ")
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}